interface CapabilityToggleProps {
  label: string
  glyph: string
  on: boolean
  onToggle: () => void
}

export function CapabilityToggle({ label, glyph, on, onToggle }: CapabilityToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12.5px] font-medium border-[1.5px] cursor-pointer font-sans transition-colors ${
        on
          ? 'bg-primary-soft border-primary text-primary-deep'
          : 'bg-s2 border-line-soft text-muted hover:text-ink-2'
      }`}
    >
      <span>{glyph}</span> {label}
    </button>
  )
}

interface CapabilityToggleRowProps {
  bringADish: boolean
  outdoorActivity: boolean
  onToggleDish: () => void
  onToggleOutdoor: () => void
}

export function CapabilityToggleRow({ bringADish, outdoorActivity, onToggleDish, onToggleOutdoor }: CapabilityToggleRowProps) {
  return (
    <div className="flex gap-2">
      <CapabilityToggle label="Dish coordination" glyph="🍽" on={bringADish} onToggle={onToggleDish} />
      <CapabilityToggle label="Outdoor details"   glyph="🥾" on={outdoorActivity} onToggle={onToggleOutdoor} />
    </div>
  )
}
